// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__4-3_H","obliqueLineWrap":"membershipbadge_obliqueLineWrap__26JKq","obliqueLine":"membershipbadge_obliqueLine__hM0DB"};